import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { AppointmentPage } from './pages/AppointmentPage';
import { ContactPage } from './pages/ContactPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <div className="min-h-screen bg-white font-sans flex flex-col" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Header data-id="element-2" />

      <main className="flex-grow" data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<ServicesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/appointment" element={<AppointmentPage data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
        </Routes>
      </main>

      <Footer data-id="element-15" />
    </div>;
}